module.exports = {
  LOCAL: 'lc.m.piaoniu.com',
  BETA: 'mbeta.piaoniu.com',
  PRERELEASE: 'm.piaoniu.com',
  PRODUCTION: 'm.piaoniu.com',
  PRERELEASE_IP: 'mnodeapi.piaoniu.com',
  PRODUCTION_IP: 'mnodeapi.piaoniu.com',
  requestIP () {
    switch (process.env.APP_ENV) {
      case 'beta':
        return this.BETA
      case 'prerelease':
        return this.PRERELEASE_IP
      case 'production':
        return this.PRODUCTION_IP
      default:
        return this.BETA
    }
  },
  pageHost () {
    // return this.BETA
    return this.PRODUCTION
    // switch (process.env.APP_ENV) {
    //   case 'beta':
    //     return this.BETA
    //   case 'prerelease':
    //     return this.PRERELEASE
    //   case 'production':
    //     return this.PRODUCTION
    //   default:
    //     return this.LOCAL
    // }
  }
}



// WEBPACK FOOTER //
// ./src/mods/hosts.js